module.exports = __webpack_public_path__ + "media/img/landing/banner1-e400be8ca1115f460f65b7c1086cbe07.png";